import { adminAPIService, newhopeAPIService } from './index'

const route = 'admins'

export const googleLogin = (googleAccessToken) => {
  const body = `method=google&access_token=${googleAccessToken}`
  return adminAPIService({
    url: `${route}/login`,
    method: 'post',
    data: body,
  })
}

export const getUserData = () => newhopeAPIService({
  url: `${route}/me`,
  method: 'get',
})

// export const getUserData = () => adminAPIService({
//   url: `${route}/current`,
//   method: 'get',
// })

// export const getUserRoutePermission = () => adminAPIService({
//   url: `${route}/current/permissions`,
//   method: 'get',
// })

export default {
  getUserId() {
    return adminAPIService({
      url: `${route}/current`,
      method: 'get',
    })
  }
}
